import React, { memo, useCallback } from 'react'

import { Textarea } from '@cgtrader/triangle-ui/dist/src/ssr-index'

import useTranslation from 'Pods/ThreeDStudio/Hooks/useTranslation'
import { useThreeDStudioStore } from 'Pods/ThreeDStudio/Store'
import { setPrompt } from 'Pods/ThreeDStudio/Store/actions/renderSettings'

function PromptField() {
  const t = useTranslation()
  const prompt = useThreeDStudioStore(state => state.renderSettings.prompt)

  const handleChange = useCallback((event) => {
    setPrompt(event.target.value)
  }, [])

  return (
    <div className="render-tab__field">
      <label className="render-tab__label cgt-body-base-semibold" htmlFor="render-prompt">
        {t('viewerSidebar.enhance.render.promptLabel')}
      </label>
      <Textarea
        id="render-prompt"
        isPilot
        rows={3}
        value={prompt}
        placeholder={t('viewerSidebar.enhance.render.promptPlaceholder')}
        onChange={handleChange}
        textareaClassName="render-tab__prompt"
      />
    </div>
  )
}

export default memo(PromptField)
